import React from 'react';

// Renders a client-supplied legal text from src/content/legalTexts.js.
function LegalDocument({ doc, headingLevel = 'h1' }) {
  const Title = headingLevel;
  return (
    <div className="r4l-legal-doc">
      <Title className="main-heading">{doc.title}</Title>
      <p className="r4l-legal-updated">Last updated: {doc.updated}</p>
      {doc.sections.map((section) => (
        <div key={section.heading}>
          <h2 className="inner-heading">{section.heading}</h2>
          {section.paragraphs?.map((text) => <p key={text}>{text}</p>)}
          {section.bullets && (
            <ul className="terms-list">
              {section.bullets.map((text) => <li key={text}>{text}</li>)}
            </ul>
          )}
          {section.table && (
            <div className="r4l-legal-table">
              <table className="table">
                <thead>
                  <tr>{section.table.columns.map((col) => <th scope="col" key={col}>{col}</th>)}</tr>
                </thead>
                <tbody>
                  {section.table.rows.map((row) => (
                    <tr key={row[0]}>{row.map((cell, i) => <td key={i}>{cell}</td>)}</tr>
                  ))}
                </tbody>
              </table>
            </div>
          )}
          {section.after?.map((text) => <p key={text}>{text}</p>)}
          {section.lines && (
            <address className="r4l-legal-address">
              {section.lines.map((line) => <div key={line}>{line}</div>)}
            </address>
          )}
        </div>
      ))}
    </div>
  );
}

export default LegalDocument;
